import { GET_STUDENT_STATUS_BY_USERID } from "../actions/types";

const initialState = [];

export default function(state = initialState, action) {
  switch (action.type) {
    case GET_STUDENT_STATUS_BY_USERID:
      return action.payload;
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/getApplicationStatusByStudentId.js